import { Box } from '@mui/material';
import EmptyPlaceholder from 'shared/components/EmptyPlaceholder';

interface DataSetsInventoryProps {
  loading: boolean;
}

const DatasetsInventoryCard: React.FC<DataSetsInventoryProps> = (
  props
): React.ReactElement => {
  const { loading } = props;
  return (
    <>
      {!loading && (
        <Box className="app-plain-card empty-content">
          <EmptyPlaceholder
            icon={
              <img color="gray" width={50} src="/images/icons/ic_data.svg" />
            }
            title="No Dataset yet"
            message="Get started by adding your first Dataset to the inventory"
          />
        </Box>
      )}
    </>
  );
};

export default DatasetsInventoryCard;
